import { useEffect } from 'react';
import { readAssetBlob } from '../media/opfs-store';
import { loadSessionFromStorage, saveSessionToStorage } from './session-store';
import { AUTOSAVE_KEY, useStudio } from './studio-store';

export function useAutosave(): { hasSavedSession: boolean; clearSavedSession: () => void } {
  const assets = useStudio((s) => s.assets);
  const tracks = useStudio((s) => s.tracks);
  const loop = useStudio((s) => s.loop);
  const scriptText = useStudio((s) => s.scriptText);
  const hydrate = useStudio((s) => s.hydrate);
  const setAssetUrl = useStudio((s) => s.setAssetUrl);

  useEffect(() => {
    const session = loadSessionFromStorage(AUTOSAVE_KEY);
    if (session && session.assets.length > 0) {
      hydrate({
        assets: session.assets,
        tracks: session.tracks,
        loop: session.loop,
        scriptText: session.scriptText,
      });
      for (const asset of session.assets) {
        if (asset.opfsKey && !asset.url) {
          void readAssetBlob(asset.id).then((blob) => {
            if (blob) setAssetUrl(asset.id, URL.createObjectURL(blob));
          });
        }
      }
    }
  }, [hydrate, setAssetUrl]);

  useEffect(() => {
    const timer = setTimeout(() => {
      saveSessionToStorage(AUTOSAVE_KEY, { assets, tracks, loop, scriptText });
    }, 800);
    return () => clearTimeout(timer);
  }, [assets, tracks, loop, scriptText]);

  const clearSavedSession = () => {
    localStorage.removeItem(AUTOSAVE_KEY);
  };

  return { hasSavedSession: Boolean(localStorage.getItem(AUTOSAVE_KEY)), clearSavedSession };
}
